import React from 'react';
import { FieldProps, useField } from 'formik';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme: any) => {
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column'
    },
    btnWrapper: {
      display: 'flex'
    },
    btn: {
      outline: 'none',
      padding: '11.5px 16px',
      background: '#FAFAFA',
      borderRadius: '50px',
      border: '1px solid transparent',
      color: '#4D4D4D',
      cursor: 'pointer'
    },
    active: {
      outline: 'none',
      padding: '11.5px 16px',
      background: 'white',
      borderRadius: '50px',
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer'
    },
    text: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1
    },
    label: {
      marginBottom: '0.75rem',
      fontSize: '0.75rem',
      fontWeight: 600
    }
  };
});

type OptionType = {
  value: string | number;
  text: string;
};

interface Props extends FieldProps {
  options: OptionType[];
  label?: string;
  className?: string;
  onChange?: () => void;
}

const Switcher = ({ options, field, label, className, onChange }: Props) => {
  const classes = useStyles();

  const [
    ,
    { error, touched, value: currentValue, initialValue },
    { setValue }
  ] = useField(field.name);

  const isError = initialValue
    ? typeof error === 'string' && touched
    : typeof error === 'string';

  return (
    <div className={classNames(classes.wrapper, className)}>
      {label && (
        <label
          style={{ color: isError ? 'red' : 'inherit' }}
          className={classes.label}
        >
          {label}
        </label>
      )}
      <div className={classes.btnWrapper}>
        {options.map(({ value, text }) => {
          const isActive = value === currentValue;
          return (
            <button
              type="button"
              onClick={() => {
                setValue(value);
                if (onChange) {
                  onChange();
                }
              }}
              className={isActive ? classes.active : classes.btn}
              key={value}
            >
              <Typography className={classes.text}>{text}</Typography>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Switcher;
